import { connect, ConnectedProps } from 'react-redux';

import LoadingIndicator from 'dashboard/components-lib/LoadingIndicator';
import { MessageType } from 'dashboard/lib/interfaces/Message';
import { showMessage } from 'dashboard/redux/actions/messages';
import { RootState } from 'dashboard/redux/store';
import { loadStripeInvoicePdfUrl } from 'dashboard/redux/thunk-actions/invoice';
import { loadInvoicesList } from 'dashboard/redux/thunk-actions/invoices';
import DashboardOrganizationBillingInvoicesView from 'dashboard/views/DashboardOrganizationBillingInvoicesView';
import useApiLoader from 'lib/hooks/useApiLoader';
import { isPermissionsError, permissionsErrorMessage } from 'lib/permissions-errors';

const DashboardOrganizationBillingInvoicesRoute = ({
  invoices,
  loadInvoicesList,
  showMessage,
  loadStripeInvoicePdfUrl,
}: PropsFromRedux) => {
  const { loading: loadingInvoices } = useApiLoader({
    loader: () => loadInvoicesList(),
    deps: [loadInvoicesList],
    onError: (error) => {
      if (isPermissionsError(error)) {
        showMessage(permissionsErrorMessage(error), MessageType.Failure);
      } else {
        showMessage('Could not load invoices', MessageType.Failure);
      }
    },
    onNetworkError: () => showMessage('Could not load invoices', MessageType.Failure),
  });

  if (loadingInvoices) {
    return <LoadingIndicator />;
  } else {
    return (
      <DashboardOrganizationBillingInvoicesView
        invoices={invoices}
        loadStripeInvoicePdfUrl={loadStripeInvoicePdfUrl}
      />
    );
  }
};

const mapStateToProps = (state: RootState) => ({
  invoices: state.invoices.invoices,
});

const mapDispatchToProps = {
  loadInvoicesList,
  showMessage,
  loadStripeInvoicePdfUrl,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(DashboardOrganizationBillingInvoicesRoute);
